import React from "react";
import { PencilLineIcon } from "lucide-react";
type PendingNoteProps = {
  children: React.ReactNode;
  tone?: "light" | "dark";
};

/** Marca visible de borrador para datos comerciales que todavía no se confirmaron. */
export function PendingNote({
  children,
  tone = "light"
}: PendingNoteProps) {
  const dark = tone === "dark";
  return <div className={`flex items-start gap-2.5 rounded-lg border border-dashed px-4 py-3 text-sm ${dark ? "border-gold/50 bg-gold/5 text-gold-cream" : "border-gold-dark/50 bg-gold-cream text-[#164BBB]"}`} data-id="element-214" data-mp="354arp4bj1tot">
      <PencilLineIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-215" data-mp="3k19tgbjp6sbd" />
      <span data-id="element-216" data-mp="3jz75ry60pb9t">
        <strong data-id="element-217" data-mp="3o2vfame7mgxp">Pendiente:</strong> {children}
      </span>
    </div>;
}